export default __webpack_public_path__ + "static/media/arrowDownGrey.d8022f40.svg";